export default __webpack_public_path__ + "static/media/ic_twitter.16b327b3.svg";